/* Tnaheed — hero slider: autoplay w/ progress, pause control, swipe, keyboard, RTL */
(function(){
'use strict';
var d=document,RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
Array.prototype.forEach.call(d.querySelectorAll('[data-th-slider]'),function(root){
  var slides=[].slice.call(root.querySelectorAll('.th-slide')),dots=[].slice.call(root.querySelectorAll('.th-hs__dot'));
  var n=slides.length,cur=0,elapsed=0,last=0,hover=false,focus=false,inView=true;
  var speed=(parseFloat(root.getAttribute('data-speed'))||7)*1000;
  var paused=RM||root.getAttribute('data-autoplay')!=='true';
  var toggle=root.querySelector('[data-th-hs-toggle]'),vp=root.querySelector('.th-hs__viewport');
  var rtl=function(){return getComputedStyle(root).direction==='rtl';};
  var L=function(k){return root.getAttribute('data-l-'+k)||k;};
  if(n<2){root.classList.add('is-single');return;}
  var setPaused=function(p){paused=p;root.classList.toggle('is-paused',p);if(toggle)toggle.setAttribute('aria-label',p?L('play'):L('pause'));};
  var warm=function(i){var s=slides[(i+n)%n];if(!s)return;[].forEach.call(s.querySelectorAll('img[loading=lazy]'),function(im){im.loading='eager';});};
  var go=function(i){
    i=(i+n)%n;if(i===cur)return;
    var a=slides[cur],b=slides[i];
    a.classList.remove('is-active');a.setAttribute('aria-hidden','true');a.inert=true;
    b.classList.add('is-active');b.removeAttribute('aria-hidden');b.inert=false;
    dots.forEach(function(dt,j){dt.classList.toggle('is-active',j===i);dt.setAttribute('aria-current',j===i?'true':'false');dt.style.setProperty('--p',0);});
    cur=i;elapsed=0;
    root.setAttribute('data-tone',b.getAttribute('data-tone')||'dark');
    if(paused&&dots[cur])dots[cur].style.setProperty('--p',1);
    warm(cur+1);
  };
  slides.forEach(function(s,j){if(j){s.inert=true;}});
  root.setAttribute('data-tone',slides[0].getAttribute('data-tone')||'dark');
  setPaused(paused);
  if(paused&&dots[0])dots[0].style.setProperty('--p',1);
  warm(1);
  var running=function(){return !paused&&!hover&&!focus&&inView&&!d.hidden;};
  var tick=function(now){
    var dt=Math.min(100,now-(last||now));last=now;
    if(running()){elapsed+=dt;var p=Math.min(1,elapsed/speed);if(dots[cur])dots[cur].style.setProperty('--p',p.toFixed(4));if(p>=1)go(cur+1);}
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
  root.querySelector('[data-th-hs-next]').addEventListener('click',function(){go(cur+1);});
  root.querySelector('[data-th-hs-prev]').addEventListener('click',function(){go(cur-1);});
  if(toggle)toggle.addEventListener('click',function(){setPaused(!paused);if(!paused&&dots[cur])dots[cur].style.setProperty('--p',0),elapsed=0;});
  dots.forEach(function(dt,j){dt.addEventListener('click',function(){go(j);});});
  if(window.matchMedia&&matchMedia('(hover: hover)').matches){
    vp.addEventListener('pointerenter',function(){hover=true;});
    vp.addEventListener('pointerleave',function(){hover=false;});
  }
  root.addEventListener('focusin',function(){focus=true;});
  root.addEventListener('focusout',function(e){if(!root.contains(e.relatedTarget))focus=false;});
  root.addEventListener('keydown',function(e){
    if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
    if(e.target.closest('input,textarea'))return;
    var fwd=(e.key==='ArrowRight')!==rtl();go(cur+(fwd?1:-1));
  });
  if('IntersectionObserver' in window){new IntersectionObserver(function(es){inView=es[0].isIntersecting;},{threshold:.25}).observe(root);}
  var x0=null,y0=0,moved=false;
  vp.addEventListener('pointerdown',function(e){if(e.pointerType==='mouse'&&e.button!==0)return;x0=e.clientX;y0=e.clientY;moved=false;});
  vp.addEventListener('pointerup',function(e){
    if(x0===null)return;var dx=e.clientX-x0,dy=e.clientY-y0;x0=null;
    if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)){moved=true;go(cur+((dx<0)!==rtl()?1:-1));}
  });
  vp.addEventListener('pointercancel',function(){x0=null;});
  vp.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  vp.addEventListener('dragstart',function(e){e.preventDefault();});
});
})();